import axios from "axios";

export default (url="https://wordle.roshanlasiwa.com.np/api")=>{
    return axios.create({
        baseURL:url,
    })
}
